import React from 'react'
import * as R from 'ramda'
import PropTypes from 'prop-types'
import ContentBox from '../../../layout/component/ContentBox'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import Select from '../../../form/component/Select'
import Checkbox from '../../../form/component/Checkbox'
import ValidationMessageList from '../../../validation/component/ValidationMessageList'
import currentUserHasAccess from '../../../../util/widget-helper'
import { IMPRINT_SCAN_STATUS_WIDGET } from '../../../process/ui-definition/process-ui'


const REASON_LIST = [
    {
        id: 'out_of_tray',
        value: 'Out of tray',
    },
    {
        id: 'shallow',
        value: 'Shallow',
    },
    {
        id: 'distortions',
        value: 'Distortions',
    },
    {
        id: 'pulls',
        value: 'Pulls',
    },
    {
        id: 'washed_margins',
        value: 'Washed margins',
    },
    {
        id: 'bubbles_folds',
        value: 'Bubbles/folds',
    },
    {
        id: 'saliva',
        value: 'Saliva',
    },
    {
        id: 'not_enough_space',
        value: 'Not enough space',
    },
    {
        id: 'pressed',
        value: 'Pressed',
    },
    {
        id: 'silicone_not_mixed_well',
        value: 'Silicone not mixed well',
    },
    {
        id: 'used_wrong_tray',
        value: 'Used wrong tray',
    },
    {
        id: 'others',
        value: 'Others',
    },
]

const computeReasonArray = (context, reasonIndex, name, value) => {
    const reasonList = context.reasonList ? R.clone(context.reasonList) : []
    const shipment = reasonList[reasonIndex] || {}
    shipment[name] = value
    reasonList[reasonIndex] = shipment
    return reasonList
}


const ImprintScanStatusWidget = ({ readOnly, context, changeProcessContext, saveProcessContext, salesOrder, validationMessageList }) => {
    if (!currentUserHasAccess(IMPRINT_SCAN_STATUS_WIDGET)) {
        return null
    }

    if (salesOrder.type !== 'set' && salesOrder.type !== 'refinement-set') {
        return null
    }

    const reasonArray = []
    for (let reasonIndex = 0; reasonIndex < salesOrder.numberOfSetsSent; reasonIndex++) {
        reasonArray.push(reasonIndex)
    }

    return (
        <ContentBox title="Imprint and Scan Status">
            <Row>
                <Column size={12}>
                    <ValidationMessageList validationMessageList={validationMessageList}/>
                </Column>
            </Row>
            <Row>
                <Column size={2}/>
                <Column size={5}>Upper</Column>
                <Column size={5}>Lower</Column>
            </Row>
            <Row top="M">
                <Column size={2}>Send</Column>
                <Column size={5}>
                    <Checkbox
                        object={context}
                        name="sendUpperTray"
                        readOnly={readOnly}
                        onChange={(name, value) => {
                            changeProcessContext(name, value)
                            saveProcessContext()
                        }}
                    >Send upper tray</Checkbox>
                </Column>
                <Column size={5}>
                    <Checkbox
                        object={context}
                        readOnly={readOnly}
                        name="sendLowerTray"
                        onChange={(name, value) => {
                            changeProcessContext(name, value)
                            saveProcessContext()
                        }}
                    >Send lower tray</Checkbox>
                </Column>
            </Row>
            <Row top="M">
                <Column size={2}>Visually</Column>

                <Column size={5}>
                    <Checkbox
                        object={context}
                        name="upperJawVisuallyOK"
                        readOnly={readOnly}
                        onChange={(name, value) => {
                            changeProcessContext(name, value)
                            saveProcessContext()
                        }}
                    >Upper Jaw visually OK</Checkbox>
                </Column>
                <Column size={5}>
                    <Checkbox
                        object={context}
                        readOnly={readOnly}
                        name="lowerJawVisuallyOK"
                        onChange={(name, value) => {
                            changeProcessContext(name, value)
                            saveProcessContext()
                        }}
                    >Lower Jaw visually OK</Checkbox>
                </Column>
            </Row>
            <Row top="M">
                <Column size={2}>Scans</Column>
                <Column size={5}>
                    <Checkbox
                        object={context}
                        name="upperJawScanOk"
                        readOnly={readOnly}
                        onChange={(name, value) => {
                            changeProcessContext(name, value)
                            saveProcessContext()
                        }}
                    >Upper Jaw scan OK</Checkbox>
                </Column>
                <Column size={5}>
                    <Checkbox
                        object={context}
                        readOnly={readOnly}
                        name="lowerJawScanOK"
                        onChange={(name, value) => {
                            changeProcessContext(name, value)
                            saveProcessContext()
                        }}
                    >Lower Jaw scan OK</Checkbox>
                </Column>
            </Row>
            <Row top="M">
                <Column size={12}>Problem with impression</Column>
            </Row>
            {reasonArray.map(reasonIndex => {
                const reasonObject = (context.reasonList && context.reasonList[reasonIndex]) ? context.reasonList[reasonIndex] : {}
                return (
                    <Row top="M" key={reasonIndex}>
                        <Column size={2}>Shipment # {reasonIndex + 1}</Column>
                        <Column size={5}>
                            <Select object={reasonObject}
                                name="lower"
                                readOnly={readOnly}
                                valueList={REASON_LIST}
                                addEmpty={true}
                                onChange={(name, value) => {
                                    const reasonList = computeReasonArray(context, reasonIndex, name, value)
                                    changeProcessContext('reasonList', reasonList)
                                    saveProcessContext()
                                }}/>
                        </Column>
                        <Column size={5}>
                            <Select object={reasonObject}
                                name="upper"
                                readOnly={readOnly}
                                valueList={REASON_LIST}
                                addEmpty={true}
                                onChange={(name, value) => {
                                    const reasonList = computeReasonArray(context, reasonIndex, name, value)
                                    changeProcessContext('reasonList', reasonList)
                                    saveProcessContext()
                                }}/>
                        </Column>
                    </Row>
                )
            })}
        </ContentBox>
    )
}

ImprintScanStatusWidget.propTypes = {
    readOnly: PropTypes.bool,
    context: PropTypes.object.isRequired,
    changeProcessContext: PropTypes.func.isRequired,
    saveProcessContext: PropTypes.func.isRequired,
    salesOrder: PropTypes.object.isRequired,
    validationMessageList: PropTypes.array.isRequired,
}

export default ImprintScanStatusWidget



// WEBPACK FOOTER //
// ./src/modules/sales-order/component/task-widget/ImprintScanStatusWidget.js